import { Image } from "antd";
import React, { useEffect, useState } from "react";
import firstPhoto from "../../../assets/Rectangle 23.png";
import classes from "./ForUs.module.css";
import { ReactComponent as SecondTruck } from "../../../assets/secondTruckSvg.svg";
import { ReactComponent as FirstTruck } from "../../../assets/firstTruckSvg.svg";
import FirstNews from "../../../assets/firstNews.png";

import InfoCards from "../InfoCards";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ShopImage from "../../../assets/Rectangle 17.png";
import TestImage from "../../../assets/Rectangle 18.png";
import MisionImage from "../../../assets/missionImage.png";
import VisionImage from "../../../assets/visionImage.png";
import PostmanTeam from "../../../assets/postmanTeam.png";
import { Link } from "react-router-dom";
import NewsDiv from "./NewsDiv";

const ForUs = () => {
	const [value, setValue] = useState(0);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 994);

	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 994);
		};

		window.addEventListener("resize", handleResize);

		handleResize();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<>
			<div className={classes.bossContainer}>
				<div className={classes.mainContainer}>
					<div className={classes.textContainer}>
						<h1 className={classes.h1Text}>Për NE</h1>
						<p className={classes.pText}>
							Tejkalojmë pritshmëritë e klientëve tanë me çdo
							dërgesë, duke <br /> ofruar një përvojë të
							jashtëzakonshme për secilin përdorues.
						</p>
					</div>
				</div>
				<div className={classes.secondComponent}>
					<SecondTruck className={classes.truckSvg} />
					<div className={classes.secondFirstItem}>
						<p className={classes.secondFirstItemText}>
							Misioni ynë
						</p>
						<p className={classes.secondFirstItemDesc}>
							Në POSTMAN, misioni ynë është të ofrojmë shërbime të
							shpejta, të sigurta dhe të besueshme të dorëzimit
							për klientët tanë në Kosovë, Shqipëri dhe Maqedoninë
							e Veriut, duke përdorur teknologji moderne dhe një
							rrjet të gjerë të logjistikës.
						</p>
					</div>
					<Image src={MisionImage} preview={false} />
				</div>
				<div className={classes.thirdContainer}>
					<div className={classes.thirdImageText}>
						<Image src={VisionImage} preview={false} />
						<div className={classes.thirdTextContainer}>
							<p className={classes.thirdTitle}>Vizioni ynë</p>
							<p>
								Vizioni ynë është të qëndrojmë lider në
								industrinë e shërbimeve postare dhe logjistike
								në nivel kombëtar dhe ndërkombëtar. Ne aspirojmë
								të jemi zgjedhja e parë për të gjitha nevojat e
								dërgesave, duke vendosur standarde të larta për
								cilësi, shpejtësi dhe inovacion.{" "}
							</p>
							<p>
								Përmes përmirësimit të vazhdueshëm dhe
								inovacioneve teknologjike, ne synojmë të
								krijojmë një ambient të besueshëm për klientët
								tanë.
							</p>
						</div>
					</div>
				</div>
				<div className={classes.fourthContainer}>
					<FirstTruck className={classes.firstTruck} />
					<div className={classes.fourthImageText}>
						<Image src={PostmanTeam} preview={false} />
						<div className={classes.thirdTextContainer}>
							<p className={classes.thirdTitle}>Ekipa jonë</p>
							<p>
								Pas suksesit tonë qëndron forca e ekipit tanë në
								secilën pjesë brenda POSTMAN. Ne jemi një grup
								profesionistësh të përkushtuar, të cilët ndajnë
								një pasion të përbashkët për shërbimet e
								suksesshme të dorëzimit dhe përkushtimin ndaj
								klientit.
							</p>
							<p>
								Secili anëtar i ekipit tonë sjell përvojë të
								pasur dhe aftësi unike që ndihmojnë në ofrimin e
								shërbimeve tona me cilësi të lartë. Duke punuar
								së bashku, ne synojmë të përmbushim dhe
								tejkalojmë pritjet e klientëve dhe jemi gati për
								{"t'i"} përballuar sfidat dhe për të arritur
								suksesin bashkarisht si një ekip.
							</p>
						</div>
						<SecondTruck className={classes.secondTruck} />
					</div>
				</div>
				{/* <NewsDiv /> */}
			</div>
			{/* <div className={classes.firstContainer}>
				<div className={classes.firstContainerText}>
					<h1 className="font-criteria italic font-semibold font-600 text-4xl leading-14 text-purple-700 w-8/12 text-left">
						Për Ne
					</h1>
					<p className={classes.paragraph}>
						Ne jemi partneri juaj i besueshëm për dërgesat tuaja
						brenda territorit të Kosovës. Secila pako trajtohet në
						mënyrë të sigurt dhe profesinale si brenda depos tonë
						ashtu edhe gjatë transportit e deri në destinacionin
						final të pakos.
					</p>
					<p className={classes.paragraph}>
						Ne ju ofrojmë sistemin e avancuar elektronik me shumë
						vegla pune që ju lehtësojnë menagjimin e porosive dhe
						shitjeve tuaja, sepse ne e vlerësojmë kohën tuaj.
					</p>
				</div>
				<div>
					<Image src={firstPhoto} preview={false} />
				</div>
			</div>

			<InfoCards />
			<div className={classes.secondContainer}>
				{isMobile ? (
					<>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="basic tabs example"
								variant="scrollable"
							>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Rritje e vazhdueshme
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Që prej themelimit të kompanisë,
												vazhdimisht kemi shënuar rritje
												në treg.
											</p>
										</div>
									}
								/>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Përkushtim
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Ne jemi të përkushtuar në
												ofrimin e shërbimeve
												profesionale për klientët tanë.
											</p>
										</div>
									}
								/>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Në çdo vend
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Postman bënë transportin e
												dërgesave në çdo vend brenda
												Kosovës dhe përmes partnerëve
												tanë në Shqipëri dhe Maqedoni të
												veriut.
											</p>
										</div>
									}
								/>
							</Tabs>
							<Box>
								{value === 0 && (
									<Box>
										<Image
											src={ShopImage}
											preview={false}
										/>
									</Box>
								)}
								{value === 1 && (
									<Box>
										<Image
											src={TestImage}
											preview={false}
										/>
									</Box>
								)}
								{value === 2 && (
									<Box>
										<Image
											src={ShopImage}
											preview={false}
										/>
									</Box>
								)}
							</Box>
						</Box>
					</>
				) : (
					<>
						<Box>
							<Tabs
								orientation="vertical"
								variant="scrollable"
								aria-label="Vertical tabs example"
								sx={{ borderRight: 1, borderColor: "divider" }}
								className={classes.tabs}
								value={value}
								onChange={handleChange}
							>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Rritje e vazhdueshme
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Që prej themelimit të kompanisë,
												vazhdimisht kemi shënuar rritje
												në treg.
											</p>
										</div>
									}
								/>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Përkushtim
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Ne jemi të përkushtuar në
												ofrimin e shërbimeve
												profesionale për klientët tanë.
											</p>
										</div>
									}
								/>
								<Tab
									label={
										<div className="text-start">
											<p className="font-criteria italic font-semibold text-2xl leading-9 text-left">
												Në çdo vend
											</p>
											<p className="font-inter text-base font-normal leading-6 text-left text-[#0E0E0ECC]">
												Postman bënë transportin e
												dërgesave në çdo vend brenda
												Kosovës dhe përmes partnerëve
												tanë në Shqipëri dhe Maqedoni të
												veriut.
											</p>
										</div>
									}
								/>
							</Tabs>
							<Box>
								{value === 0 && (
									<Box>
										<Image
											src={ShopImage}
											preview={false}
										/>
									</Box>
								)}
								{value === 1 && (
									<Box>
										<Image
											src={TestImage}
											preview={false}
										/>
									</Box>
								)}
								{value === 2 && (
									<Box>
										<Image
											src={ShopImage}
											preview={false}
										/>
									</Box>
								)}
							</Box>
						</Box>
					</>
				)}
			</div>
			<InfoDiv /> */}
		</>
	);
};

export default ForUs;
